<div class="modal-header">
  <div class="modal-header-x" (click)="bsModalRef.hide()">
    <i-feather name="x"></i-feather>
  </div>
</div>
<reactions-details [postHashHex]="postHashHex" [bsModalRef]="bsModalRef"></reactions-details>
